import React, { useEffect } from 'react';
import './App.css';
import { LifeStylePage } from './components/pages/LifeStylePage';
import { UserHomePage } from './components/pages/UserHomePage';
import { HouseHomePage } from './components/pages/HouseHomePage';
import { FinanceHomePage } from './components/pages/FinanceHomePage';
import { GarageHomePage } from './components/pages/GarageHomePage';
import { ToDoListPage } from './components/pages/ToDoListPage';
import { ShoppingPage } from './components/pages/ShoppingPage';
import { ImportantDatesPage } from './components/pages/ImportantDatesPage';
import { AccessDeniedPage } from './components/pages/system/AccessDeniedPage';
import { NotFoundPage } from './components/pages/system/NotFoundPage';
import { LoginPage } from './components/pages/account/LoginPage';

import { Router, Switch } from 'react-router';

import { DashboardLayoutRoute } from './components/layouts/DashboardLayoutRoute';
import { FullscreenLayoutRoute } from './components/layouts/FullscreenLayoutRoute';

import { createBrowserHistory } from 'history';
import { useDispatch } from 'react-redux';
import { userLoginAction } from './redux/actions';
import { apiGetCurrentUser } from './services/UserService';

const history = createBrowserHistory();

const anonymousUser = { anonymous: true, role: 'Neznámý uživatel', username: '' };

const readStoredUser = () => {
  try {
    const storedUser = window.localStorage.getItem('currentUser');
    const user = storedUser ? JSON.parse(storedUser) : null;
    return user && user.anonymous === false ? user : null;
  } catch {
    return null;
  }
};

function App() {

  const dispatch = useDispatch();

  useEffect(() => {
    const storedUser = readStoredUser();

    if (storedUser) {
      dispatch(userLoginAction(JSON.stringify(storedUser)));
    }

    apiGetCurrentUser().then(
      (response) => {
        const currentUser = response.data;

        // server vrací i prostý text, když cookie nedokáže vyhodnotit - to není odpověď o anonymitě
        if (currentUser && typeof currentUser.anonymous === 'boolean') {
          if (currentUser.anonymous) {
            window.localStorage.removeItem('currentUser');
          }
          dispatch(userLoginAction(JSON.stringify(currentUser)));
        } else if (!storedUser) {
          dispatch(userLoginAction(JSON.stringify(anonymousUser)));
        }
      },
      (error) => {
        if (error.response && error.response.status === 401) {
          window.localStorage.removeItem('currentUser');
          dispatch(userLoginAction(JSON.stringify(anonymousUser)));
        } else if (!storedUser) {
          dispatch(userLoginAction(JSON.stringify(anonymousUser)));
        }
      }
    );
  }, [dispatch]);

  return (
    <div className="flexible-content">
      <Router history={history}>
        <Switch>

          {/* Root  */}

          <DashboardLayoutRoute exact path="/" component={UserHomePage} />

          {/* Dashboards  */}
          <DashboardLayoutRoute path="/userhomepage" component={UserHomePage} />
          <DashboardLayoutRoute path="/househomepage" component={HouseHomePage} />
          <DashboardLayoutRoute path="/garagehomepage" component={GarageHomePage} />
          <DashboardLayoutRoute path="/financehomepage" component={FinanceHomePage} />

          {/* Account Pages */}
          <FullscreenLayoutRoute path="/login" component={LoginPage} />

          {/* Domik Pages */}
          <DashboardLayoutRoute path="/todolist" component={ToDoListPage} />
          <DashboardLayoutRoute path="/lifestyle" component={LifeStylePage} />
          <DashboardLayoutRoute path="/shopping" component={ShoppingPage} />
          <DashboardLayoutRoute path="/importantdates" component={ImportantDatesPage} />

          {/* System Pages */}
          <FullscreenLayoutRoute path="/401" component={AccessDeniedPage} />
          <FullscreenLayoutRoute path="*" exact={true} component={NotFoundPage} />

        </Switch>
      </Router>
    </div>
  );
}

export default App;
